const lightOpacity = 0.6;

const focusRed = [173, 9, 29];
const lightFocusRed = [...focusRed, lightOpacity];

export const tourColor = [192, 20, 33];
export const lightTourColor = [...tourColor, lightOpacity];

export const backgroundColor = [255, 255, 255];
export const lightBackgroundColor = [...backgroundColor, lightOpacity];

export const stopOverColor = [251, 194, 0];
export const lightStopOverColor = [...stopOverColor, lightOpacity];

export const textColor = [19, 15, 3];
export const lightTextColor = [...textColor, lightOpacity];

export const selfDrawnHikingColor = "#4169e1";

export const TRACK_Z_INDEX = 200;

export const sketchControlPoint = [
  {
    "z-index": TRACK_Z_INDEX,
    "circle-radius": 16,
    "circle-fill-color": lightFocusRed,
  },
  {
    "z-index": TRACK_Z_INDEX,
    "circle-radius": 8,
    "circle-fill-color": focusRed,
  },
];
